import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '~/pages/Match/subpages/Previous/components/Squad/styles';
import Table from '~/components/Table';
import { theme } from '~/styles/theme';
import * as S from './styles';

export default function SquadContent({
  squad,
  substitutes,
  isLocal,
  showAll,
  hoveredPlayer,
  onHover,
  isFetching,
  withScroll,
}) {
  const { t } = useTranslation();

  const columnsTitulares = React.useMemo(
    () => [
      {
        Header: t('titulars'),
        accessor: player => (
          <S.PlayerCell
            hovered={hoveredPlayer === player.shirtNumber}
            onMouseOver={() => {
              onHover(player.shirtNumber ? player.shirtNumber.toString() : '0');
            }}
          >
            <span>{player.shirtNumber ? player.shirtNumber : '-'}</span>
            {player.nickname ? player.nickname : '-'}
          </S.PlayerCell>
        ),
      },
    ],
    [t, hoveredPlayer, onHover]
  );

  const columnsSuplentes = React.useMemo(
    () => [
      {
        Header: t('substitutes'),
        accessor: player => (
          <S.SubstituteCell>
            <S.SubstituteLabel>{player.shirtNumber}</S.SubstituteLabel>
            <S.SubstituteLabel bold>{player.nickname}</S.SubstituteLabel>
          </S.SubstituteCell>
        ),
      },
    ],
    [t]
  );
  return (
    <Styled.SquadContainer isLocal={isLocal}>
      <S.Scroll className="scroll" withScroll={withScroll}>
        <div className="scroll-content">
          <Table
            onMouseOut={() => {
              onHover('0');
            }}
            columns={columnsTitulares}
            data={squad}
            styleOptions={{
              backgroundColor: 'transparent',
              primaryColor: isLocal
                ? theme.whiteWithOpacity
                : theme.dark5Opacity,
              secondaryColor: isLocal
                ? theme.light2Opacity
                : theme.dark4Opacity,
              textColor: isLocal ? theme.dark : theme.white,
              textHeaderColor: isLocal ? theme.dark : theme.white,
              fullWidth: true,
            }}
            isFetching={isFetching}
            placeholderNumElements={11}
          />
        </div>
      </S.Scroll>

      {showAll && (
        <Table
          columns={columnsSuplentes}
          data={substitutes}
          styleOptions={{
            backgroundColor: 'transparent',
            primaryColor: isLocal ? theme.whiteWithOpacity : theme.dark5Opacity,
            secondaryColor: isLocal ? theme.light2Opacity : '',
            textColor: isLocal ? theme.dark : theme.white,
            textHeaderColor: isLocal ? theme.dark : theme.white,
            fullWidth: true,
          }}
          isFetching={isFetching}
          placeholderNumElements={11}
        />
      )}
    </Styled.SquadContainer>
  );
}

SquadContent.propTypes = {
  squad: PropTypes.array,
  substitutes: PropTypes.array,
  isLocal: PropTypes.bool,
  showAll: PropTypes.bool,
  hoveredPlayer: PropTypes.string,
  onHover: PropTypes.func,
  isFetching: PropTypes.bool,
  withScroll: PropTypes.bool,
};

SquadContent.defaultProps = {
  squad: [],
  substitutes: [],
  isLocal: false,
  showAll: true,
  hoveredPlayer: '0',
  onHover: () => {},
  isFetching: false,
  withScroll: false,
};
